/* SB · Sort gode deals: læg i kurv (temaets kurv-skuffe, som sb-kampagne.js) og anmeldelses-slider. */
(function () {
  if (window.sgdInit) return;
  window.sgdInit = true;

  /* ---------- læg i kurv → temaets kurv-skuffe ---------- */
  function addToCart(btn) {
    var id = btn.getAttribute('data-variant');
    if (!id || btn.disabled) return;
    var routes = (window.FoxTheme && FoxTheme.routes) || {};
    var url = routes.cart_add_url || '/cart/add.js';
    var label = btn.getAttribute('data-label') || btn.textContent;
    btn.setAttribute('data-label', label);
    btn.disabled = true;
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    }).then(function (r) { return r.json(); }).then(function (data) {
      if (data && data.status && data.status >= 400) throw new Error(data.description || 'error');
      btn.classList.add('is-added');
      btn.textContent = btn.getAttribute('data-added') || label;
      setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = label; btn.disabled = false; }, 1400);
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
    }).catch(function () {
      btn.textContent = btn.getAttribute('data-error') || label;
      setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 2000);
    });
  }
  document.addEventListener('click', function (e) {
    var add = e.target.closest('.sgd [data-sgd-add]');
    if (add) { e.preventDefault(); addToCart(add); }
  });

  /* ---------- anmeldelser: pile, prikker, træk med musen, «Læs hele» ---------- */
  function initReviews(root) {
    var track = root.querySelector('[data-sgd-track]');
    if (!track || track.dataset.sgdReady) return;
    track.dataset.sgdReady = '1';
    var cards = Array.prototype.slice.call(track.children);
    if (!cards.length) return;
    var dotsEl = root.querySelector('[data-sgd-dots]');
    var gap = function () { return parseFloat(getComputedStyle(track).columnGap) || 0; };
    var step = function () { return cards[0].offsetWidth + gap(); };
    var perView = function () { return Math.max(1, Math.round(track.clientWidth / step())); };
    var snapTo = function (i) {
      var max = track.scrollWidth - track.clientWidth;
      track.scrollTo({ left: Math.max(0, Math.min(max, i * step())), behavior: 'smooth' });
    };
    var prev = root.querySelector('[data-sgd-prev]'), next = root.querySelector('[data-sgd-next]');
    if (prev) prev.addEventListener('click', function () { snapTo(Math.round(track.scrollLeft / step()) - perView()); });
    if (next) next.addEventListener('click', function () { snapTo(Math.round(track.scrollLeft / step()) + perView()); });

    function markDot() {
      if (!dotsEl) return;
      var i = Math.round(track.scrollLeft / step());
      Array.prototype.forEach.call(dotsEl.children, function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    function dots() {
      if (!dotsEl || !track.clientWidth) return;
      var pages = Math.max(1, cards.length - perView() + 1);
      dotsEl.innerHTML = '';
      for (var i = 0; i < pages; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', (dotsEl.getAttribute('data-label') || 'Anmeldelse') + ' ' + (i + 1));
        b.addEventListener('click', (function (n) { return function () { snapTo(n); }; })(i));
        dotsEl.appendChild(b);
      }
      markDot();
    }
    track.addEventListener('scroll', function () { requestAnimationFrame(markDot); });

    /* mus: træk (touch bruger native scroll + snap) */
    var down = false, sx = 0, sl = 0, moved = 0, lastX = 0, lastT = 0, vel = 0, t;
    track.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      down = true; moved = 0; vel = 0; sx = lastX = e.clientX; sl = track.scrollLeft; lastT = performance.now();
      clearTimeout(t);
    });
    window.addEventListener('mousemove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx;
      if (Math.abs(dx) > 6) track.classList.add('is-drag');
      var now = performance.now(); vel = (e.clientX - lastX) / Math.max(1, now - lastT); lastX = e.clientX; lastT = now;
      moved = Math.abs(dx);
      track.scrollLeft = sl - dx;
    });
    window.addEventListener('mouseup', function () {
      if (!down) return;
      down = false;
      if (moved <= 6) { track.classList.remove('is-drag'); return; }
      var i = track.scrollLeft / step();
      i = Math.abs(vel) > 0.3 ? (vel < 0 ? Math.ceil(i) : Math.floor(i)) : Math.round(i);
      snapTo(i);
      t = setTimeout(function () { track.classList.remove('is-drag'); }, 450);
    });
    track.addEventListener('click', function (e) { if (moved > 6) { e.preventDefault(); e.stopPropagation(); moved = 0; } }, true);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });

    /* Læs hele / Vis mindre */
    track.addEventListener('click', function (e) {
      var b = e.target.closest('[data-sgd-more]');
      if (!b) return;
      var c = b.closest('.sgd-rv');
      var open = c.classList.toggle('is-open');
      b.textContent = open ? b.getAttribute('data-less') : b.getAttribute('data-more');
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    function clampCheck() {
      cards.forEach(function (c) {
        if (c.classList.contains('is-open')) return;
        var q = c.querySelector('blockquote'), b = c.querySelector('[data-sgd-more]');
        if (q && b) b.hidden = q.scrollHeight <= q.clientHeight + 2;
      });
    }
    if ('ResizeObserver' in window) {
      new ResizeObserver(function () { requestAnimationFrame(function () { clampCheck(); dots(); }); }).observe(track);
    } else {
      window.addEventListener('resize', function () { clampCheck(); dots(); });
    }
    clampCheck(); dots();
  }
  function initAll() { document.querySelectorAll('.sgd').forEach(initReviews); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
